import { Method, send } from './MyHttp';

/**
 * 정보
 */
export const Get = (device_no, date, success, fail) => {
    let paramsT = {};

    send(Method.GET, `/deviceData/${device_no}/${date}`, paramsT, success, fail);
};

export const GetTime = (device_no,startTime,endTime, success, fail) => {
    let paramsT = {};

    send(Method.GET, `/deviceData/${device_no}/${startTime}/${endTime}`, paramsT, success, fail);
};

export const Get10Time = (device_no,startTime,endTime, success, fail) => {
    let paramsT = {};

    send(Method.GET, `/deviceData/time10/${device_no}/${startTime}/${endTime}`, paramsT, success, fail);
};


/**
 * 리스트
 */
export const GetList = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.GET, '/deviceData', paramsT, success, fail);
};

/**
 * 리스트 (마지막 데이터)
 */
export const GetListLast = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.GET, '/deviceData/last', paramsT, success, fail);
};

export const GetHrv = (device_no, success, fail) => {
    let paramsT = {};

    send(Method.GET, `/deviceData/${device_no}`, paramsT, success, fail);
};

export const UpdateKiosk = (data, success, fail) => {
    
    
    const paramsT = {
        device_sn: data.device_sn,
        device_no: Number(data.device_no) || 0,
        member_no: Number(data.member_no) || 0,
        name: data.name,
        sex: Number(data.sex) || 0,
        birth: data.birth,
        feel: Number(data.feel) || 0,
        heart_avg: Number(data.heart_avg) || 0,
        resp_avg: Number(data.resp_avg) || 0,
        RMSSD: data.rmssd || 0.0,
        SDNN: data.sdnn || 0.0,
        pNN50: data.pnn50 || 0.0,
        baevsky_si: data.baevsky_si || 0.0,
        time: data.date || null,
        result_data : data.result_data || null
    };



    send(Method.POST, '/Kiosk', paramsT, success, fail);
};